import { render, staticRenderFns } from "./SlcPagination.vue?vue&type=template&id=116b9972&scoped=true&"
import script from "./SlcPagination.vue?vue&type=script&lang=ts&"
export * from "./SlcPagination.vue?vue&type=script&lang=ts&"
import style0 from "./SlcPagination.vue?vue&type=style&index=0&id=116b9972&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116b9972",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDatePicker,VIcon,VMenu,VTooltip})
